export const uiTypes = {
  BUTTONROW: 'BUTTONROW',
  CAPTION: 'CAPTION',
  MENUSECTION: 'MENUSECTION',
  CHATBUBBLE: 'CHATBUBBLE',
};
